import { createSlice } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";

// --- Redux Slice ---
const loadingSlice = createSlice({
  name: "loading",
  initialState: {
    circleLoading: false,
  },
  reducers: {
    setCircleLoading: (state, action) => {
      state.circleLoading = action.payload;
    },
  },
});

export const { setCircleLoading } = loadingSlice.actions;
export default loadingSlice.reducer;

// --- Custom Hook ---
export const useLoading = () => {
  const dispatch = useDispatch();
  const circleLoading = useSelector((state) => state.loading.circleLoading);

  const updateCircleLoading = (value) => {
    dispatch(setCircleLoading(value));
  };

  return { circleLoading, setCircleLoading: updateCircleLoading };
};
